import { slugifyString } from '@nucleus/src-platform/data/text';
import { AuthorWeb } from '@nucleus/types/web/posts/author';
import { useCallback } from 'react';
import { generatePath } from 'react-router-dom';
import { useLocalization } from './useLocalization';

export type AuthorIndexDocument = { slug: string; displayName?: string };

export const useAuthorPath = (basePath: string): ((author: AuthorWeb | AuthorIndexDocument) => string) => {
  const localize = useLocalization();

  return useCallback(
    (author: AuthorWeb | AuthorIndexDocument) => {
      return generatePath(':basePath/:authors/:authorSlug', {
        basePath: basePath,
        authors: slugifyString(localize('authors', 'authors')),
        authorSlug: author.slug,
      });
    },
    [basePath]
  );
};
